import {
  MockMap,
} from '@ama-sdk/core';
import {
  AcceptanceRepository,
  BaggageRepository,
  combineCheckInBaggagePolicies,
  ContextualSeatmapDataRepository,
  createJourney,
  createMockData,
  createMockDataWithResponse,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';
import {
  journeyMultiNotificationFor3Adt,
  roundTripBoardingPassResult,
} from '../../mock/data';

export const ow1Journey3AdtPaxSelectionContactRetrieve: MockMap = {
  generateBoardingPasses: [
    createMockDataWithResponse(roundTripBoardingPassResult, 201)
  ],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, [{
    code: '10000',
    title: 'No unpaid service',
    type: 'error',
    id: '10000'
  }])],
  getRegulatoryDetails: [createMockData(RegulatoryDetailsReplyDataRepository.DEFAULT)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [
    createMockDataWithResponse([
      createJourney({
        template: {
          ...journeyMultiNotificationFor3Adt
        }
      })
    ], 201)
  ],
  retrieveJourney: [
    createMockData(
      createJourney({
        template: {
          ...journeyMultiNotificationFor3Adt,
          acceptance: AcceptanceRepository.ACCEPTED
        }
      })
    )
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(ContextualSeatmapDataRepository.DEFAULT)]
};
